import anime from 'animejs'
import BB_Cart from './cart';
import BB_Header from './header';

export default class BB_Archive_Product {
    constructor() {
        BB_Archive_Product.init()
    }
    static init() {
        console.log('archive_product.js init');

        jQuery('.ob-prod-img-wrap').on('mouseenter', BB_Archive_Product.img_hover)
        jQuery('.ob-prod-img-wrap').on('mouseleave', BB_Archive_Product.img_leave)

        jQuery('.ob-quick-cart-btn').on('click', BB_Archive_Product.quick_cart)
        jQuery('.ob-quick-cart-close-btn').on('click', BB_Archive_Product.quick_cart_close)
        // jQuery('.ob-select-wrap select').on('change', BB_Archive_Product.quick_cart_select)
        jQuery('.ob-add-to-cart-btn').on('click', BB_Archive_Product.add_to_cart)

    }
    static img_hover() {
        let hover_imgs = this.querySelectorAll('.ob-hover-img')

        let long_hover_ani = () => {
            anime({
                targets: hover_imgs,
                opacity: 1,
                delay: anime.stagger(1200),
                easing: 'easeOutQuint',
                complete: function () {
                    
                    hover_imgs.forEach((el, key) => {
                        if (el.classList.contains('ob-last-hover-img')) return;

                        el.style.removeProperty("opacity")
                    });

                    setTimeout(() => {
                        hover_imgs[hover_imgs.length - 1].style.removeProperty("opacity")

                        setTimeout(() => {
                            long_hover_ani()
                        }, 300)

                    }, 100)

                }
            });

        };

        long_hover_ani()
    }
    static img_leave() {

        let all_hover_imgs = document.querySelectorAll('.ob-hover-img')
        let hover_imgs = this.querySelectorAll('.ob-hover-img')
        let last_img = this.querySelector('.ob-last-hover-img')

        anime.remove(all_hover_imgs);
        last_img.style.opacity = 1

        hover_imgs.forEach((el, key) => {
            if (el.classList.contains('ob-last-hover-img')) return;

            el.style.removeProperty("opacity")
        });

        setTimeout(() => {
            hover_imgs[hover_imgs.length - 1].style.removeProperty("opacity")
        }, 100)
    }
    static quick_cart(e) {
        e.preventDefault();

        let $this = jQuery(this);
        let product_container = $this.closest('.ob-product');
        let cart_options = product_container.find('.ob-quick-cart-options');


        cart_options.removeClass('ob-inactive')
        product_container.addClass('ob-quick-cart-active')




        // console.dir()

        // BB_Cart.sidebar_open()
    }
    static quick_cart_close(e) {
        e.preventDefault();

        let $this = jQuery(this);
        let product_container = $this.closest('.ob-product');
        let cart_options = product_container.find('.ob-quick-cart-options');

        cart_options.addClass('ob-inactive')
        product_container.removeClass('ob-quick-cart-active')
    }
    // static quick_cart_select() {
    //     let $this = jQuery(this);

    //     console.dir($this.val())


    //     // BB_Cart.sidebar_open()
    // }
    static add_to_cart(e) {
        e.preventDefault();

        let $this = jQuery(this);
        let product_container = $this.closest('.ob-product');
        let cart_select = product_container.find('.ob-select-wrap select');
        let quick_options_wrap = product_container.find('.ob-quick-cart-options-wrap')

        quick_options_wrap.addClass('ob-quick-cart-options-loading')

        BB_Header.cart_start_loading()
        BB_Cart.start_loading()

        BB_Archive_Product.add_to_cart_ajax([cart_select.data('product-id'), cart_select.val(), 1], product_container)
    }
    static async add_to_cart_ajax(product_data, product_container) {
        const request_body = {
            security: ajax_object.add_to_cart_nonce,
            action: "add_to_cart_action",
            data: product_data
        }
        const request = {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: jQuery.param(request_body)
        }
        try {
            const respose = await fetch(ajax_object.ajax_url, request);
            const response_json = await respose.json();
            let quick_options_wrap, cart_options;

            if (product_container) {
                quick_options_wrap = product_container.find('.ob-quick-cart-options-wrap')
                cart_options = product_container.find('.ob-quick-cart-options');
            }
            console.log(response_json);

            if (response_json.success) {
                if (product_container) {
                    quick_options_wrap.removeClass('ob-quick-cart-options-loading')
                    cart_options.addClass('ob-inactive')
                    product_container.removeClass('ob-quick-cart-active')
                }

                BB_Cart.refresh()
            }

        } catch (err) {
            console.log(err);
        }
    }
}

